var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inIframe
    ? _c("router-view")
    : _c("div", { staticClass: "flex flex-column bg-f2 h100-vh" }, [
        _c(
          "div",
          { staticClass: "flex header" },
          [
            _c("div", { staticClass: "org-info" }),
            _c(
              "el-menu",
              {
                staticClass: "flex-auto",
                attrs: {
                  "default-active": _vm.projectActive,
                  mode: "horizontal"
                }
              },
              _vm._l(_vm.project, function(item) {
                return _c(
                  "el-menu-item",
                  {
                    key: item.value,
                    staticClass: "f16",
                    attrs: { index: item.value }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              }),
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "flex w0 flex-auto content" }, [
          _c(
            "div",
            {
              staticClass: "flex flex-shrink flex-column menu",
              class: { "is-collapse": _vm.isCollapse }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex-shrink pad20-l pad15-r flex items-center justify-between title"
                },
                [
                  !_vm.isCollapse
                    ? _c("div", [_vm._v(_vm._s(_vm.projectName))])
                    : _vm._e(),
                  _c("i", {
                    staticClass: "f20 pointer el-icon-s-fold",
                    on: {
                      click: function($event) {
                        _vm.isCollapse = !_vm.isCollapse
                      }
                    }
                  })
                ]
              ),
              _c(
                "div",
                { staticClass: "w0 flex-auto scroll-y" },
                [
                  _c(
                    "el-menu",
                    {
                      attrs: {
                        "default-active": "2",
                        "active-text-color": "#1890ff",
                        collapse: _vm.isCollapse
                      }
                    },
                    [
                      _vm._l(_vm.menuList, function(item, index) {
                        return [
                          item.child && item.child.length
                            ? _c(
                                "el-submenu",
                                { key: index, attrs: { index: item.id } },
                                [
                                  _c(
                                    "template",
                                    { slot: "title" },
                                    [
                                      _c("svg-icon", {
                                        staticClass: "icon",
                                        attrs: {
                                          "icon-class":
                                            item.icon || "未定义菜单"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "title" },
                                          slot: "title"
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._l(item.child, function(
                                    child,
                                    childIndex
                                  ) {
                                    return [
                                      child.child && child.child.length
                                        ? _c(
                                            "el-submenu",
                                            {
                                              key: childIndex,
                                              attrs: { index: child.id }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "title" },
                                                [_vm._v(_vm._s(child.name))]
                                              ),
                                              _vm._l(child.child, function(
                                                child2,
                                                childIndex2
                                              ) {
                                                return _c(
                                                  "el-menu-item",
                                                  {
                                                    key: childIndex2,
                                                    attrs: { index: child2.id }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(child2.name) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        : _c(
                                            "el-menu-item",
                                            {
                                              key: childIndex,
                                              attrs: { index: child.id }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(child.name) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                    ]
                                  })
                                ],
                                2
                              )
                            : _c(
                                "el-menu-item",
                                { key: index, attrs: { index: item.id } },
                                [
                                  _c("i", { staticClass: "el-icon-setting" }),
                                  _c(
                                    "span",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                ]
                              )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "flex-auto scroll-y" },
            [_c("router-view")],
            1
          )
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }